import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function ImageFader({ images, alt = "", interval = 4200, className = "", testIdPrefix = "fader" }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % images.length), interval);
    return () => clearInterval(t);
  }, [images.length, interval]);

  return (
    <div className={`relative overflow-hidden ${className}`} data-testid={`${testIdPrefix}-container`}>
      <AnimatePresence mode="sync">
        <motion.img
          key={images[index]}
          src={images[index]}
          alt={alt}
          className="absolute inset-0 w-full h-full object-cover"
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
        />
      </AnimatePresence>
      <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2 z-10">
        {images.map((_, d) => (
          <button
            key={d}
            data-testid={`${testIdPrefix}-dot-${d}`}
            onClick={() => setIndex(d)}
            aria-label={`Slide ${d + 1}`}
            className={`h-1 transition-all duration-500 ${d === index ? "w-8 bg-gold" : "w-3 bg-white/40 hover:bg-white/70"}`}
          />
        ))}
      </div>
    </div>
  );
}
